import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Form } from 'react-bootstrap';
import NumberInput from '../../../../components/NumberInput/NumberInput';
import CustomSelect from '../../../../components/Select/Select';

export type StateTaxFormProps = {
  data: any;
  collectData: (data: any) => void;
};

const StateTaxForm = ({ data, collectData }: StateTaxFormProps) => {
  const { state, martialStatus, numberOfAllowances, additionalAmount } = data;

  const selectOptions = [
    { value: '1', label: 'Single' },
    { value: '2', label: 'Married' },
    { value: '3', label: 'Married, but withhold at higher single rate' },
  ];

  const handleAdditionalAmountChange = (e: number | null | undefined) => {
    collectData({
      ...data,
      additionalAmount: e,
    });
  };

  const handleNumberOfAllowancesChange = (e: number | null | undefined) => {
    collectData({
      ...data,
      numberOfAllowances: e,
    });
  };

  const handleMartialStatusChange = (e: any) => {
    const selected = selectOptions.find((el) => el.value === e);
    collectData({
      ...data,
      martialStatus: selected,
    });
  };

  return (
    <Form>
      {state.value !== 'NJ' && (
        <>
          <CustomSelect
            label="Marital Status"
            className="mt-7"
            options={selectOptions}
            onChange={handleMartialStatusChange}
            value={martialStatus.value || ''}
            disabled={state.value === 'NJ'}
          />

          <NumberInput
            label="Number of Allowances"
            className="mt-7"
            value={numberOfAllowances || 0}
            minValue={'0'}
            maxValue={'17'}
            onChange={handleNumberOfAllowancesChange}
            disabled={state.value === 'NJ'}
          />
        </>
      )}

      <NumberInput
        label={state.value === 'NJ' ? 'Amount' : 'Additional Amount (optional)'}
        icon={light('dollar')}
        className="mt-7"
        placeholder={'0'}
        minValue={'0'}
        maxValue={'17'}
        value={additionalAmount || 0}
        onChange={handleAdditionalAmountChange}
      />
    </Form>
  );
};

export default StateTaxForm;
